import Shuffle from 'shuffle-seed';

const PredictableShuffle = (key, values) => (
  Shuffle.shuffle(values, key.replace(/[\w\-]/g, (v) => v.charCodeAt(0).toString(16)))
);

export default PredictableShuffle;
